import React from 'react';
import classes from "./OtpPage.module.css";
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { FaChevronRight, FaCopyright } from 'react-icons/fa6';
import { useState } from 'react';
import OTPInput from 'react-otp-input';
import { useEffect } from 'react';
import { v4 as uuidv4 } from "uuid";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { setUserDetails } from '../store/slices/userSlice';
import { SendOtpAPI, VerifyOtpAPI } from '../http/http';

const OtpPage = () => {
    const [otp, setOtp] = useState("");
    const [timer, setTimer] = useState(120);
    const navigate = useNavigate();
    const [msisdn, setMsisdn] = useState("");
    const [extRef, setExtRef] = useState(null);
    const [referenceNo, setReferenceNo] = useState(null);
    const [resend, setResend] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
            setExtRef(location?.state?.extRef);
            setReferenceNo(location?.state?.referenceNo);
        }
        else {
            navigate("/");
        }
    }, [location]);

    const handleFormSubmission = async () => {
        try {
            if (otp.length <= 5) {
                return;
            }
            setLoading(true);
            const response = await VerifyOtpAPI(msisdn, otp, referenceNo, extRef);
            console.log(response, 'response---');
            setLoading(false);
            navigate("/subscription-processing", {
                state: {
                    msisdn: msisdn
                }
            })
        } catch (error) {
            setLoading(false);
            console.log(error, 'error---');

            if (error?.response?.data?.status == 0) {
                toast.error("Wrong OTP");
            }
            else if (error?.response?.data?.status == 1) {
                toast.info("Subscribe Successfully");
                navigate("/low-balance");
            }
            else {
                toast.error("Something Went Wrong!");
            }
        }
    }

    const resendOtpHandler = async () => {
        try {
            setResendLoading(true);

            const response = await SendOtpAPI(msisdn);
            setTimer(120);
            setResendLoading(false);
            if (response?.data?.status == 1) {
                setResend(true);
                setOtp("");
                toast.success("OTP Resend Successfully!");
            }
            else {
                toast.error("Failed to Send OTP!");
            }
        } catch (error) {
            setResendLoading(false);
            toast.error("Something Went Wrong!");
        }
    }

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer((prevTimer) => prevTimer - 1);
        }, 1000);

        return () => {
            clearInterval(countdown);
        };
    }, []);

    useEffect(() => {
        if (timer <= 0) {
            navigate("/");
        }
    }, [timer]);

    return (
        <main className={classes.main}>
            <header className={classes.header}>
                <nav className={classes.nav}>
                    <div className={classes.logo_container}>
                        <img src="/assets/images/logo.png" alt="logo" className={classes.logo} />
                    </div>
                    {/* 
                    <div className={classes.nav_items}>
                        <button type="button" className={classes.nav_item_btn}
                            onClick={() => navigate(`/subscribe?ext_ref=${extRef}`)}
                        >
                            Subscribe
                        </button>
                    </div> */}
                </nav>
            </header>


            <section className={classes.section_landing_page}>
                <div className={classes.grid_container}>
                    <div className={classes.grid_section_one}>

                        <div className={classes.otp_container}>


                            <div className={classes.otp_description}>
                                <h2 className={classes.title}>OTP Verification</h2>
                                <p className={classes.text}>
                                    We have sent {resend && "another"} one time pin to
                                    <span className={classes.bold}> +94 {msisdn} </span>
                                    via SMS.
                                </p>
                            </div>

                            <div className={classes.otp_input_container}>
                                <OTPInput
                                    value={otp}
                                    shouldAutoFocus
                                    onChange={setOtp}
                                    numInputs={6}
                                    renderSeparator={<span className={classes.gap}></span>}
                                    renderInput={(props) => (
                                        <input {...props} type="number" className={classes.input_box} />
                                    )}
                                />
                            </div>

                            <div className={classes.time_container}>
                                <p className={classes.time_text}>Time remaining: {timer} seconds</p>
                            </div>

                            {(loading || resendLoading) ? <div style={{ width: "100%", display: "grid", placeContent: "center" }}>
                                <p>Loading....</p>
                            </div> : (
                                <div className={classes.btn_container}>
                                    <button
                                        type="button"
                                        className={classes.confirm_btn}
                                        disabled={loading}
                                        onClick={handleFormSubmission}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        type="button"
                                        className={classes.resend_btn}
                                        disabled={resendLoading}
                                        onClick={resendOtpHandler}
                                    >
                                        Resend OTP
                                    </button>
                                </div>
                            )}

                        </div>

                    </div>
                    <div className={classes.grid_section_two}>
                        <img src="/assets/images/kids-group.png" alt="kids-group" className={classes.kids_group_image} />


                        <p className={classes.portal_description}>
                            Online educational platform for digital skills where students aged between 2-10 learn through fun and interactive videos
                        </p>

                        <div className={classes.grid_sub_container}>
                            <div className={classes.kids_image_container}>
                                <img src="/assets/images/kids.png" alt="kids" className={classes.kids_image} />
                            </div>
                            <div className={classes.kids_info}>
                                <p className={classes.kids_info_text_one}>Made For</p>
                                <p className={classes.kids_info_text_two}>- Kids</p>
                            </div>
                        </div>
                    </div>

                </div>
                <img src="/assets/images/Union.png" alt="union" className={classes.union_image} />
                <img src="/assets/images/learning.png" alt="union" className={classes.learning_image} />

            </section>

            <section className={classes.footer}>
                <div className={classes.container}>
                    <div className={classes.footer_container}>
                        <div className={classes.footer_logo_container}>
                            <img src="/assets/images/logo.png" alt="logo" className={classes.footer_logo} />
                        </div>

                        <div className={classes.copyright_container}>
                            <FaCopyright className={classes.copyright_icon} />
                            <p className={classes.copyright_text}>
                                Rainboo Softmate Pvt Ltd
                            </p>
                        </div>
                    </div>


                </div>
            </section>

        </main>

    )
}

export default OtpPage